import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NearByServiceManagementRoutingModule } from './near-by-service-management-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NearByServiceManagementRoutingModule
  ]
})
export class NearByServiceManagementModule { }
